"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeUtils = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var _ = require("lodash");
var commonFunctions_1 = require("../../../commonFunctions");
var HomeUtils = /** @class */ (function () {
    function HomeUtils() {
    }
    HomeUtils.prototype.getAnnualPremium = function (tier, factors) {
        if (tier === services_1.BRONZE_TIER) {
            return factors.bronzePremiums.totalAnnualPremium;
        }
        else if (tier === services_1.SILVER_TIER) {
            return factors.silverPremiums.totalAnnualPremium;
        }
        else {
            return factors.goldPremiums.totalAnnualPremium;
        }
    };
    HomeUtils.prototype.getMonthlyPremium = function (tier, factors) {
        if (tier === services_1.BRONZE_TIER) {
            return factors.bronzePremiums.totalMonthlyPremium;
        }
        else if (tier === services_1.SILVER_TIER) {
            return factors.silverPremiums.totalMonthlyPremium;
        }
        else {
            return factors.goldPremiums.totalMonthlyPremium;
        }
    };
    HomeUtils.prototype.renderOptionalWording = function (coverIncluded) {
        if (coverIncluded) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "col", children: (0, jsx_runtime_1.jsx)("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon", className: "wolf-green-tick" }) }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)("div", { className: "col", children: (0, jsx_runtime_1.jsx)("p", { className: "unlimited-cover margin-bottom-0", children: "optional" }) }));
        }
    };
    HomeUtils.prototype.getChangesMade = function (interaction, oldInteraction) {
        var tierChangeWording = this.getTierChangeWording(interaction, oldInteraction);
        var mtaSpecificWording = this.getMTASpecificWording(interaction, oldInteraction);
        var mtaSpecificWordingElem = [];
        if (mtaSpecificWording !== null && mtaSpecificWording.length > 0) {
            mtaSpecificWording.forEach(function (wording) { return mtaSpecificWordingElem.push((0, jsx_runtime_1.jsx)("li", { children: wording })); });
        }
        if (mtaSpecificWording !== null || tierChangeWording !== "") {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' ', "You have chosen to:", (0, jsx_runtime_1.jsxs)("ul", { className: "m-0", children: [mtaSpecificWordingElem, tierChangeWording && (0, jsx_runtime_1.jsx)("li", { children: tierChangeWording })] })] }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    HomeUtils.prototype.getTierChangeWording = function (interaction, oldInteraction) {
        var newTier = interaction === null || interaction === void 0 ? void 0 : interaction.coverTier;
        var previousTier = oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.coverTier;
        if (!previousTier || newTier === previousTier) {
            return "";
        }
        switch (newTier) {
            case services_1.HomeCoverTier.GOLD:
                return "Upgrade to ".concat(this.tierDetail(services_1.HomeCoverTier.GOLD));
            case services_1.HomeCoverTier.SILVER:
                if (previousTier !== services_1.HomeCoverTier.GOLD) {
                    return "Upgrade to ".concat(this.tierDetail(services_1.HomeCoverTier.SILVER));
                }
                else {
                    return "Change cover level to ".concat(this.tierDetail(services_1.HomeCoverTier.SILVER));
                }
            case services_1.HomeCoverTier.BRONZE:
                return "Change cover level to ".concat(this.tierDetail(services_1.HomeCoverTier.BRONZE));
            default:
                return "";
        }
    };
    HomeUtils.prototype.tierDetail = function (tier) {
        switch (tier) {
            case services_1.BRONZE_TIER:
                return "Allianz Online Bronze";
            case services_1.SILVER_TIER:
                return "Allianz Online Silver";
            default:
                return "Allianz Online Gold";
        }
    };
    HomeUtils.prototype.getMTASpecificWording = function (interaction, oldInteraction) {
        var _a, _b, _c, _d, _e, _f;
        var mtaChanges = [];
        var isChangeAddressMTA = this.isChangeAddressMTA(interaction);
        if (isChangeAddressMTA) {
            var newAddress = (_c = (_b = (_a = interaction === null || interaction === void 0 ? void 0 : interaction.realEstate) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.fullAddress;
            var oldAddress = (_f = (_e = (_d = oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.realEstate) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.fullAddress;
            mtaChanges.push("Change address from ".concat(oldAddress, " to ").concat(newAddress));
        }
        else {
            if (this.isEditPropertyDetails(interaction, oldInteraction)) {
                mtaChanges.push("Edit property details");
            }
            if (this.isEditPropertyUse(interaction, oldInteraction)) {
                mtaChanges.push("Edit property use");
            }
        }
        if (this.isEditPolicyHolder(interaction, oldInteraction)) {
            mtaChanges.push("Edit policyholder(s) details");
        }
        if (this.hasExtrasChanges(interaction, oldInteraction)) {
            mtaChanges.push("Edit extra covers");
        }
        if (this.isEditCoverLevel(interaction, oldInteraction)) {
            mtaChanges.push(this.getCoverLevelChanges(interaction, oldInteraction));
        }
        return mtaChanges;
    };
    HomeUtils.prototype.hasExtrasChanges = function (interaction, oldInteraction) {
        var oldExtras = oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.annualHomeFixedAddons;
        var newExtras = interaction === null || interaction === void 0 ? void 0 : interaction.annualHomeFixedAddons;
        var optionalExtraChanged = function (oldExtra, newExtra) { return !oldExtra !== !newExtra; };
        // If contents cover is removed, contents related optional extras are removed as well,
        // in this scenario we don't want the extra changes wording to be present.
        var contentsCoverRemoved = (interaction === null || interaction === void 0 ? void 0 : interaction.coverLevel) === services_1.HomeCoverLevelEnum.BUILDINGS &&
            (oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.coverLevel) !== services_1.HomeCoverLevelEnum.BUILDINGS;
        var itemCoverChanged = function (oldItems, newItems) {
            var oldItemsSize = (oldItems !== null && oldItems !== void 0 ? oldItems : []).length;
            var newItemsSize = (newItems !== null && newItems !== void 0 ? newItems : []).length;
            return oldItemsSize !== newItemsSize && !(contentsCoverRemoved && !newItemsSize);
        };
        if ((interaction === null || interaction === void 0 ? void 0 : interaction.coverLevel) !== services_1.HomeCoverLevelEnum.CONTENTS &&
            optionalExtraChanged(oldExtras === null || oldExtras === void 0 ? void 0 : oldExtras.buildingAccidentalDamage, newExtras === null || newExtras === void 0 ? void 0 : newExtras.buildingAccidentalDamage)) {
            return true;
        }
        if ((interaction === null || interaction === void 0 ? void 0 : interaction.coverLevel) !== services_1.HomeCoverLevelEnum.BUILDINGS &&
            optionalExtraChanged(oldExtras === null || oldExtras === void 0 ? void 0 : oldExtras.contentsAccidentalDamage, newExtras === null || newExtras === void 0 ? void 0 : newExtras.contentsAccidentalDamage)) {
            return true;
        }
        if (optionalExtraChanged(oldExtras === null || oldExtras === void 0 ? void 0 : oldExtras.homeLegalExpenses, newExtras === null || newExtras === void 0 ? void 0 : newExtras.homeLegalExpenses)) {
            return true;
        }
        if (optionalExtraChanged(oldExtras === null || oldExtras === void 0 ? void 0 : oldExtras.homeEmergency, newExtras === null || newExtras === void 0 ? void 0 : newExtras.homeEmergency)) {
            return true;
        }
        if (itemCoverChanged(oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.valuableItems, interaction === null || interaction === void 0 ? void 0 : interaction.valuableItems)) {
            return true;
        }
        if (itemCoverChanged(oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.bicycles, interaction === null || interaction === void 0 ? void 0 : interaction.bicycles)) {
            return true;
        }
        if (itemCoverChanged(oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.specifiedItemsSelected, interaction === null || interaction === void 0 ? void 0 : interaction.specifiedItemsSelected)) {
            return true;
        }
        return false;
    };
    HomeUtils.prototype.isChangeAddressMTA = function (interaction) {
        var _a;
        return (interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_ADDRESS ||
            ((_a = interaction.uistate) === null || _a === void 0 ? void 0 : _a.subprocess) === "renewalMtaChangeAddress");
    };
    HomeUtils.prototype.isEditPropertyDetails = function (interaction, oldInteraction) {
        var _a, _b;
        return !_.isEqual(this.mapToPropertyDetails((_a = interaction === null || interaction === void 0 ? void 0 : interaction.realEstate) === null || _a === void 0 ? void 0 : _a[0]), this.mapToPropertyDetails((_b = oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.realEstate) === null || _b === void 0 ? void 0 : _b[0]));
    };
    HomeUtils.prototype.isEditPropertyUse = function (interaction, oldInteraction) {
        return !_.isEqual(this.mapToPropertyUse(interaction), this.mapToPropertyUse(oldInteraction));
    };
    HomeUtils.prototype.isEditCoverLevel = function (interaction, oldInteraction) {
        return !_.isEqual(interaction === null || interaction === void 0 ? void 0 : interaction.coverLevel, oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.coverLevel);
    };
    HomeUtils.prototype.getCoverLevelChanges = function (interaction, oldInteraction) {
        if (!_.isEqual(interaction === null || interaction === void 0 ? void 0 : interaction.coverLevel, oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.coverLevel)) {
            return "Change cover type to ".concat((0, commonFunctions_1.getCoverLevelWording)(interaction === null || interaction === void 0 ? void 0 : interaction.coverLevel));
        }
        return "";
    };
    HomeUtils.prototype.isEditPolicyHolder = function (interaction, oldInteraction) {
        return !_.isEqual(this.mapToPolicyHolder(interaction === null || interaction === void 0 ? void 0 : interaction.policyHolder), this.mapToPolicyHolder(oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.policyHolder))
            || !_.isEqual(this.mapToPolicyHolder(interaction === null || interaction === void 0 ? void 0 : interaction.jointPolicyHolder), this.mapToPolicyHolder(oldInteraction === null || oldInteraction === void 0 ? void 0 : oldInteraction.jointPolicyHolder));
    };
    HomeUtils.prototype.mapToPropertyDetails = function (data) {
        return {
            bedroomCount: (data === null || data === void 0 ? void 0 : data.bedroomCount) || null,
            bathroomCount: (data === null || data === void 0 ? void 0 : data.bathroomCount) || null,
            propertyCondition: (data === null || data === void 0 ? void 0 : data.propertyCondition) || null,
            flatRoofPercentage: (data === null || data === void 0 ? void 0 : data.flatRoofPercentage) || null,
            installedSmartHomeSystems: this.mapToSmartHomeSystems(data === null || data === void 0 ? void 0 : data.installedSmartHomeSystems),
            oilFiredHeatingInstalled: (data === null || data === void 0 ? void 0 : data.oilFiredHeatingInstalled) || null
        };
    };
    HomeUtils.prototype.mapToPropertyUse = function (data) {
        var _a;
        var property = (_a = data === null || data === void 0 ? void 0 : data.realEstate) === null || _a === void 0 ? void 0 : _a[0];
        var phData = data === null || data === void 0 ? void 0 : data.policyHolder;
        return {
            isMainHome: (property === null || property === void 0 ? void 0 : property.isMainHome) || null,
            businessUse: (property === null || property === void 0 ? void 0 : property.businessUse) || null,
            residentsType: (property === null || property === void 0 ? void 0 : property.residentsType) || null,
            adultFamilyMemberCount: (property === null || property === void 0 ? void 0 : property.adultFamilyMemberCount) || null,
            numberOfChildren: (property === null || property === void 0 ? void 0 : property.numberOfChildren) || null,
            isLeftEmpty: (property === null || property === void 0 ? void 0 : property.isLeftEmpty) || null,
            occupancyType: (property === null || property === void 0 ? void 0 : property.occupancyType) || null,
            ownershipType: (property === null || property === void 0 ? void 0 : property.ownershipType) || null,
            yearsAtProperty: (phData === null || phData === void 0 ? void 0 : phData.yearsAtProperty) || null
        };
    };
    HomeUtils.prototype.mapToSmartHomeSystems = function (data) {
        return {
            remoteHeatingControl: (data === null || data === void 0 ? void 0 : data.remoteHeatingControl) || null,
            securityCamera: (data === null || data === void 0 ? void 0 : data.securityCamera) || null,
            waterLeakDetector: (data === null || data === void 0 ? void 0 : data.waterLeakDetector) || null,
            waterShutOffValve: (data === null || data === void 0 ? void 0 : data.waterShutOffValve) || null
        };
    };
    HomeUtils.prototype.mapToPolicyHolder = function (data) {
        var _this = this;
        var _a;
        return {
            title: (data === null || data === void 0 ? void 0 : data.title) || null,
            firstName: (data === null || data === void 0 ? void 0 : data.firstName) || null,
            lastName: (data === null || data === void 0 ? void 0 : data.lastName) || null,
            employmentStatus: (data === null || data === void 0 ? void 0 : data.employmentStatus) || null,
            occupation: (data === null || data === void 0 ? void 0 : data.occupation) || null,
            occupationIndustry: (data === null || data === void 0 ? void 0 : data.occupationIndustry) || null,
            hasSecondaryOccupation: (data === null || data === void 0 ? void 0 : data.hasSecondaryOccupation) || null,
            secondaryOccupation: (data === null || data === void 0 ? void 0 : data.secondaryOccupation) || null,
            secondaryOccupationIndustry: (data === null || data === void 0 ? void 0 : data.secondaryOccupationIndustry) || null,
            maritalStatus: (data === null || data === void 0 ? void 0 : data.maritalStatus) || null,
            hasUnspentCriminalConvictions: (data === null || data === void 0 ? void 0 : data.hasUnspentCriminalConvictions) || null,
            claims: ((_a = data === null || data === void 0 ? void 0 : data.claims) === null || _a === void 0 ? void 0 : _a.map(function (c) { return _this.mapToClaim(c); })) || []
        };
    };
    HomeUtils.prototype.mapToClaim = function (data) {
        return {
            claimValue: (data === null || data === void 0 ? void 0 : data.claimValue) || null,
            claimGenericType: (data === null || data === void 0 ? void 0 : data.claimGenericType) || null,
            claimAtPropertyToInsure: (data === null || data === void 0 ? void 0 : data.claimAtPropertyToInsure) || null,
            claimType: (data === null || data === void 0 ? void 0 : data.claimType) || null,
            date: (data === null || data === void 0 ? void 0 : data.date) || null
        };
    };
    return HomeUtils;
}());
exports.HomeUtils = HomeUtils;
//# sourceMappingURL=HomeUtils.js.map